import { useState } from 'react'

import { useToast } from '@/hooks'
import { useAccountMutations } from '@/modules/account'
import { MembershipLimitError } from '@/modules/errors'
import { redirectTo } from '@/utils'
import type { TrialSignUpDetails } from '../utils/onboarding'

interface StartTrialCheckoutOptions {
  onUnexpectedFailure?: () => void
}

export const useStartTrialCheckout = ({
  onUnexpectedFailure,
}: StartTrialCheckoutOptions = {}) => {
  const { startTrial } = useAccountMutations()
  const { errorToast } = useToast()
  const [isAlreadyMember, setIsAlreadyMember] = useState(false)

  const handleFailure = (error: Error) => {
    if (error instanceof MembershipLimitError) {
      setIsAlreadyMember(true)
      return
    }
    errorToast('We could not start your trial', error)
    onUnexpectedFailure?.()
  }

  const startTrialCheckout = (details: TrialSignUpDetails) =>
    startTrial(details).then(redirectTo).catch(handleFailure)

  return { startTrialCheckout, isAlreadyMember }
}
